<template>
  <div>
    <PageTitle :title="$t('global.order-ssl-certificate')" />
    <LoadingState v-if="!packages.status.isLoaded || !certStatus.isLoaded" :size="50" />
    <div v-else class="row">
      <div class="col-lg-8">
        <Card :disable-title="true">
          <CertificateAddWithCertForm :on-change="onChange" :cert="cert" :packages="packages" />
        </Card>
      </div>
      <div class="col-lg-4">
        <Card :disable-title="true">
          <CertificateAddSummary :summary="summary" :domains="domains" />
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, reactive } from "@vue/composition-api";
import Card from "@/components/display/Card";
import CertificateAddSummary from "@/components/smart/cards/CertificateAddSummary";
import CertificateAddWithCertForm from "@/components/smart/forms/CertificateAddWithCertForm";
import LoadingState from "@/components/display/LoadingState";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";

export default {
  name: "CertificateAddWithCertPage",
  components: {
    Card,
    CertificateAddSummary,
    CertificateAddWithCertForm,
    LoadingState,
    PageTitle,
  },
  props: {
    certId: {
      type: [Number, String],
      required: true,
    },
  },
  setup(props) {
    const cert = computed(() => store.state.certificates.item);
    const certStatus = computed(() => store.state.certificates.status);
    const packages = computed(() => store.state.sslPackages);
    const domains = computed(() =>
      store.state.certificates.item.commonName ? [cert.value.commonName] : []
    );
    const summary = reactive({ package: {} });
    const onChange = (type, value) => {
      switch (type) {
        case "package":
          summary.package = packages.value.list.find((pack) => pack.id === value);
          break;
      }
    };

    onMounted(() => {
      store.dispatch("certificates/get", props.certId);
      store.dispatch("sslPackages/getList");
    });

    return {
      cert,
      certStatus,
      domains,
      onChange,
      packages,
      summary,
    };
  },
};
</script>
